import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import PlaidBankConnector from "shared/Components/PlaidBankConnector";
import { Tooltip } from "components/Tooltip";
import { useSurmountAccountStatus } from "features/SurmountAccount/hooks";
import {
  useConnectedAccounts,
  useSurmountAccountDetails,
} from "features/Dashboard/hook";
import { userDetailSelect } from "Layout/slice/selector";
import { TransferFundsButton } from "../Navbar.styles";

export const BankConnectionAction = ({
  handlePlaidSuccess,
  handleTransferFunds,
}) => {
  const userDetails = useSelector(userDetailSelect);
  const {
    surmountPortfolio,
    isBankConnected,
    userFlags,
    hasPendingSurmountAccount,
  } = useSurmountAccountStatus();
  const { isLoading: isStatusLoading } = useConnectedAccounts();
  const {
    isLoading: isDetailsLoading,
    refetchDetails,
    refetchPortfolio,
    refetchTransactions,
    refetchDocuments,
  } = useSurmountAccountDetails(surmountPortfolio?.id);

  const onPlaidSuccess = () => {
    handlePlaidSuccess();
    refetchDetails();
    refetchPortfolio();
    refetchTransactions();
    refetchDocuments();
  };
  if (
    !userDetails?.is_surmount_internal_created ||
    !userFlags?.length ||
    isStatusLoading ||
    isDetailsLoading
  ) {
    return null;
  }

  return (
    <PlaidBankConnector onSuccess={onPlaidSuccess}>
      {({ openConnector, isLoading }) => {
        const is_pending = isBankConnected && hasPendingSurmountAccount;
        const btn = (
          <TransferFundsButton
            onClick={isBankConnected ? handleTransferFunds : openConnector}
            disabled={isLoading || is_pending}
          >
            {isBankConnected ? "Transfer Funds" : "Add Bank"}
          </TransferFundsButton>
        );

        return is_pending ? (
          <Tooltip value="Internal account is pending approval. Please wait.">
            {btn}
          </Tooltip>
        ) : (
          btn
        );
      }}
    </PlaidBankConnector>
  );
};

BankConnectionAction.propTypes = {
  handlePlaidSuccess: PropTypes.func.isRequired,
  handleTransferFunds: PropTypes.func.isRequired,
};
